import { render, staticRenderFns } from "./AdminCate1.vue?vue&type=template&id=8dbe2ee2&scoped=true&"
import script from "./AdminCate1.vue?vue&type=script&lang=js&"
export * from "./AdminCate1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dbe2ee2",
  null
  
)

export default component.exports